import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { DataTable, DataTableColumn } from '@cmhc-schl/hearth-ui';
import Body from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Body';
import Header from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Header';
import { useManualChanges } from 'Feature/Arrears/components/ArrearsErrorRecord/ManualChanges/core/useManualChanges';
import { Timestamp } from 'Feature/Arrears/components/ArrearsErrorRecord/ManualChanges/ui/common/Timestamp';
import { useFeature } from 'flagged';
import { ManualChange } from 'Feature/Arrears/components/ArrearsErrorRecord/ManualChanges/core/ManualChange';

export const featureFlagServicing = 'SERVICING_FEATURE_FLAG';

const ArrearsManualChanges = ({ arrearsFileId }: { arrearsFileId: string }) => {
  const isEnabled = useFeature(featureFlagServicing) as boolean;

  return isEnabled ? <VisibleArrearsManualChanges arrearsFileId={arrearsFileId} /> : <></>;
};

const VisibleArrearsManualChanges = ({ arrearsFileId }: { arrearsFileId: string }) => {
  const { t } = useTranslation('HbtArrearsManualChangesSection');
  const { manualChanges, loadingManualChanges, fetchManualChanges } = useManualChanges();
  useEffect(() => {
    fetchManualChanges(arrearsFileId);
  }, [arrearsFileId]);

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        bgcolor="#fff"
        margin="32px 0px 80px 0px"
        maxWidth="1920px"
      >
        <Header sx={{ padding: '0 0 10px 24px' }} size={'medium'}>
          {t('title')}
        </Header>
        <DataTable<ManualChange>
          data={manualChanges}
          autoTableLayout={true}
          uniqueKey={'loanNumber'}
          sortedColumn={null}
          isLoading={loadingManualChanges}
          onSort={() => {}}
          emptyTableMessage={t('changesTable.empty')}
        >
          <DataTableColumn
            displayName={t('changesTable.columns.loanNumber')}
            name={'loanNumber'}
            sortable={false}
            filterable={false}
          >
            {(data) => <Body size={'small'}>{data}</Body>}
          </DataTableColumn>
          <DataTableColumn
            displayName={t('changesTable.columns.editedBy')}
            name={'editedBy'}
            sortable={false}
            filterable={false}
          >
            {(data) => <Body size={'small'}>{data}</Body>}
          </DataTableColumn>
          <DataTableColumn
            displayName={t('changesTable.columns.dateChanged')}
            name={'editedDate'}
            sortable={false}
            filterable={false}
          >
            {(data) => (
              <Body size={'small'}>
                <Timestamp data={data} />
              </Body>
            )}
          </DataTableColumn>
        </DataTable>
      </Box>
    </>
  );
};

export default ArrearsManualChanges;
